// Core
import { useState } from "react";

// Definitions
import { ErrorResponse, PaymentSystemFormDataType, UsePaymentFormType } from "../types";

// Utils
import { createPayment, createWithdraw } from "../actions";

export const usePaymentForm = (): UsePaymentFormType => {
  const [violationError, setViolationError] = useState<ErrorResponse["violations"]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const onMutatePayment = async (mutatePayload: PaymentSystemFormDataType) => {
    setLoading(true);
    setViolationError([]);

    const formData = new FormData();

    formData.append("method", mutatePayload.method.toString());
    formData.append("amount", mutatePayload.amount.toString());

    if (mutatePayload.receiverWallet) {
      formData.append("receiverWallet", mutatePayload.receiverWallet.toString());
    }

    let res;

    if (mutatePayload.type === "out") {
      res = await createWithdraw(formData);
    } else {
      res = await createPayment(formData);
    }

    if (res?.errors) {
      setViolationError(res.errors);
    }

    setLoading(false);

    return res;
  };

  const errors: Record<string, string> = {};

  violationError?.forEach((item) => {
    errors[item.property] = item.error.toString();
  });

  const renderErrorMessage = (
    propertyName: string,
    violations: ErrorResponse["violations"] | null,
  ): string | null => {
    if (!violations) return "";
    const foundError = violations?.find((_error) => _error.property === propertyName);
    return foundError ? foundError.error : null;
  };

  return {
    violations: violationError,
    errors,
    onMutatePayment,
    loading,
    renderErrorMessage,
  };
};
